import { useEffect, useState } from 'react';
import { api } from '../api.js';
import { formatEur } from '@csoki/shared';
import type { SalesEntry } from '@csoki/shared';

export function SellerSales() {
  const [rows, setRows] = useState<SalesEntry[] | null>(null);
  useEffect(() => {
    api<{ sales: SalesEntry[] }>('GET', '/api/seller/purchases').then((d) => setRows(d.sales));
  }, []);

  if (!rows) return <div className="page">Loading…</div>;

  return (
    <div className="page">
      <h1>Sales</h1>
      {rows.length === 0 && <p>No sales yet.</p>}
      <table className="sales">
        <thead>
          <tr>
            <th>When</th>
            <th>Item</th>
            <th>Qty</th>
            <th>Total</th>
            <th>State</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} className={r.state}>
              <td>{new Date(r.createdAt + 'Z').toLocaleString()}</td>
              <td>{r.productName}</td>
              <td>{r.quantity}</td>
              <td>{formatEur(r.totalCents)}</td>
              <td>{r.state}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
